<template>
  <div role="group" class="radio-button-group">
    <div
      v-for="option in options"
      :key="option.value"
      class="radio-button-group-option"
    >
      <input
        :id="option.value"
        tabindex="-1"
        type="radio"
        :value="option.value"
        :name="option.name"
        :checked="option.value === selected"
        :disabled="!option.isAvailable"
        @click="onClick(option.label)"
      />
      <label :disabled="!option.isAvailable" tabindex="0" :for="option.value">
        {{ truncateText(option.label) }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButtonGroup',

  props: {
    options: {
      type: Array
    },

    selected: {
      type: String
    }
  },

  methods: {
    onClick(value) {
      if (this.selected !== value) {
        this.$emit('change', value);
      }
    },
    truncateText(string, limit = 30) {
      return string.length > limit
        ? string.substr(0, limit - 1) + '...'
        : string;
    }
  }
};
</script>
